module.exports={
	"Form": "ProjectOfficeCreateManifest",
	"Scope": "ProjectOffice-Create",
	"Descriptors":
	{
		"ProjectOfficeDetails.OfficeCode":
		{
			"Name": "Office Code",
			"Hash": "ProjectOffice-Create-OfficeCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "ProjectOffice-Create-Identity",
				"Group": "ProjectOffice-Create-Identity"
			}
		},
		"ProjectOfficeDetails.Name":
		{
			"Name": "Name",
			"Hash": "ProjectOffice-Create-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "ProjectOffice-Create-Identity",
				"Group": "ProjectOffice-Create-Identity"
			}
		},
		"ProjectOfficeDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "ProjectOffice-Create-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "ProjectOffice-Create-Contact",
				"Group": "ProjectOffice-Create-Contact"
			}
		},
		"ProjectOfficeDetails.Address":
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Create-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "3",
				"Width": 12,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		},
		"ProjectOfficeDetails.City":
		{
			"Name": "City",
			"Hash": "ProjectOffice-Create-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		},
		"ProjectOfficeDetails.State":
		{
			"Name": "State",
			"Hash": "ProjectOffice-Create-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		},
		"ProjectOfficeDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "ProjectOffice-Create-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "ProjectOffice-Create-Address",
				"Group": "ProjectOffice-Create-Address"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ProjectOffice-Create-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ProjectOffice-Create-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "ProjectOffice-Create-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "ProjectOffice-Create-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "ProjectOffice-Create-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "ProjectOffice-Create-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
